import { useRef, useState } from "react";
import { Link } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL

function Login({ setAuth }) {

  const errRef = useRef();

  const [user, setUser] = useState({
    username: "",
    password: ""
  });

  const [errMsg, setErrMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const body = user;
      const response = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });

      const parseRes = await response.json()

      // Valid token gives access
      if (parseRes.jwtToken) {
        localStorage.setItem("token", parseRes.jwtToken);
        setAuth(parseRes.role);
        setErrMsg("");
      } else {
        // Not valid token prints error
        setErrMsg(parseRes.message || "Felaktiga uppgifter");
      }
    }
    catch (err) {
      setErrMsg('Inloggning misslyckades');
      errRef.current?.focus();
    }
  }

  return (
    <>
      <div className="flex flex-col text-center items-center justify-center mx-2">
        <div className="theme-card mx-4 my-4 w-full max-w-2xl p-4">
          <form onSubmit={handleSubmit} className="flex w-auto flex-col items-center pt-6 pb-6">
            <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Välkommen</p>
            <h1 className="mt-2 text-center text-lg font-bold text-slate-800">Logga in</h1>
            <div className="mt-4 flex w-full justify-center">
              <input
                autoComplete="off"
                type="text"
                onChange={(e) => setUser({ ...user, username: e.target.value })} // Copies all properties in the object and updates username
                className="theme-input w-72"
                placeholder="E-postadress"
                required />
            </div>

            <div className="flex w-full justify-center">
              <input
                type="password"
                onChange={(e) => setUser({ ...user, password: e.target.value })}
                className="theme-input w-72"
                placeholder="Lösenord"
                required />
            </div>

            <div className="mt-2 flex w-full justify-center">
              <button className="theme-button-primary w-72">Logga in</button>
            </div>
            {errMsg && <p className="theme-alert-error mx-auto w-72">{errMsg}</p>}
            <Link className="mt-4 text-sm font-semibold text-sky-700" to="/register">Registrera konto</Link>
            <Link className="mt-4 text-sm font-semibold text-sky-700" to="/resend-verification">Nytt verifieringsmejl</Link>
            <Link className="mt-4 text-sm font-semibold text-sky-700" to="/forgot-password">Glömt lösenord?</Link>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
